import React from 'react';
import { Warning } from '@phosphor-icons/react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import './HelpCategoryPage.css';

/**
 * Top up your account Article Page
 */
const TopUpAccount = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Top up your account</h1>
                <p className="article-subtitle">
                  Learn the different ways to add funds to your WeSplit wallet, whether from a friend or by transferring assets from an external crypto wallet.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Overview</h2>
                  <p className="article-section-intro">
                    Learn how to add funds to your WeSplit wallet, whether by requesting from a friend or transferring assets from an external exchange or wallet.
                  </p>
                </div>
              </section>


              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Method 1: Receive from a Friend</h2>
                  <p className="article-section-intro">
                    If a friend uses WeSplit or has a crypto wallet, you can request funds directly.
                  </p>
                </div>

                <div className="article-subsection">
                  <ol className="article-list">
                    <li>
                      <strong>Make a Request:</strong> Navigate to the "Request" section in the app, enter the amount, and send the notification to your contact.
                    </li>
                    <li>
                      <strong>Share Your QR Code:</strong> Tap on QR code icon in your balance card. Display your unique <strong>QR code</strong> for your friend to scan. They can send funds instantly to your wallet.
                    </li>
                  </ol>
                </div>
              </section>


              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Method 2: Fund from an External Wallet</h2>
                  <p className="article-section-intro">
                    If you have funds on a crypto exchange (like Binance, Coinbase) or another personal wallet (like Phantom, Solflare), you can send them to your WeSplit account.
                  </p>
                </div>

                <div className="article-subsection">
                  <ol className="article-list">
                    <li>
                      <strong>Copy Your Public Address:</strong> Open your WeSplit wallet. Click on "Deposit" then copy your wallet address <strong>directly</strong> to your clipboard.
                    </li>
                    <li>
                      <strong>Go to Your External Wallet:</strong> Open the app or exchange where your funds are currently stored. Select "Withdraw" or "Send".
                    </li>
                    <li>
                      <strong>Complete the Transfer:</strong> Paste your WeSplit public address as the destination. Enter the amount of <strong>USDC</strong> you wish to transfer. Verify you are on the <strong>Solana network</strong>. Confirm the transaction.
                    </li>
                  </ol>
                </div>
              </section>


              <section className="article-section">
                <div className="article-warning">
                  <div className="article-warning-header">
                    <Warning className="article-warning-icon" weight="fill" />
                    <h3 className="article-warning-title">USDC on Solana Only</h3>
                  </div>
                  <div className="article-warning-content">
                    <p>
                      WeSplit exclusively supports <strong>USDC</strong> on the <strong>Solana network</strong>.
                    </p>
                    <ul className="article-list-dots">
                      <li>
                        Do not send other cryptocurrencies (like Bitcoin or Ethereum) to this address.
                      </li>
                      <li>
                        Ensure you select the <strong>Solana network</strong> when sending <strong>USDC</strong>.
                      </li>
                      <li>
                        Sending unsupported assets may result in permanent loss of funds.
                      </li>
                    </ul>
                  </div>
                </div>
              </section>

              <div className="article-separator"></div>

              <LastUpdated />

              <ArticleNavigation
                previous={{
                  title: 'Secure your Account',
                  route: getHelpRoute(getHelpArticleRoute('getting-started', 'first-split'))
                }}
                next={{
                  title: 'Create your first group',
                  route: getHelpRoute(getHelpArticleRoute('getting-started', 'create-group'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default TopUpAccount;
